import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { UserSessionService } from '../../sevices/user-session.service';

@Injectable({ providedIn: 'root' })
export class AuthSessionService {
  constructor(
    private router: Router,
    private userSession: UserSessionService
  ) {}

  logoutExpiredSession(): void {
    localStorage.removeItem('userEasy');
    sessionStorage.removeItem('userEasy');
    localStorage.setItem('isLoggedInEasy', 'false');
    sessionStorage.setItem('isLoggedInEasy', 'false');
    document.body.style.overflow = '';
    this.userSession.changeMessage('nouser');
    void this.router.navigateByUrl('/');
  }
}
